import React, { FC } from 'react';
import { BodyShort01, BodyLong01, BodyShort02, BodyLong02 } from 'ozone/atoms';
import { SubHeading2 } from './components';
import { TypeToken } from './type-token';

export const BodyStyles: FC = () => (
  <>
    <SubHeading2>Body styles</SubHeading2>
    <TypeToken component={BodyShort01}>
      This is for short paragraphs with no more than four lines and is commonly
      used in components.
    </TypeToken>
    <TypeToken component={BodyLong01}>
      This is commonly used in both the expressive and the productive type theme
      layouts for long paragraphs with more than four lines. It is a good size
      for comfortable, long-form reading. Use this for longer body copy in
      components such as accordion or structured list. Always left-align this
      type; never center it.
    </TypeToken>
    <TypeToken component={BodyShort02}>
      This is for short paragraphs with no more than four lines and is commonly
      used in the expressive type theme for layouts.
    </TypeToken>
    <TypeToken component={BodyLong02}>
      This is commonly used in the expressive type theme layouts for long
      paragraphs with more than four lines. The looser line height and larger
      size makes for comfortable, long-form reading, in mediums that allow for
      more space. This size type is rarely used for body copy in components.
      Always left-align type; never center it.
    </TypeToken>
  </>
);
